import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ACTprepContextPackage } from "./actprep-ui/context/ACTprepContextPackage";
import registerServiceWorker from "./registerServiceWorker";

const VERSION = process.env.REACT_APP_DEPLOY_VERSION || "1.0.0";
const storedVersion = localStorage.getItem("app_version");

if (storedVersion && storedVersion !== VERSION) {
  localStorage.setItem("app_version", VERSION);
  window.location.reload();
} else {
  localStorage.setItem("app_version", VERSION);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ACTprepContextPackage>
      <App />
    </ACTprepContextPackage>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
registerServiceWorker();
